import React from 'react';
import HomePage from './HomePage';

// Country-locked landing page for UK Meta Ads — same HomePage content but
// the RegionContext is forced to `uk` (GBP pricing) and the currency toggle
// is hidden. The Register CTA carries `?region=uk` so the new user lands in
// their correct region from day one.
const UkLandingPage = () => <HomePage lockedRegion="uk" />;

export default UkLandingPage;
